<template>
  <VContainer class="how-to-pay-page">
    <VRow>
      <VCol cols="12">
        <div class="how-to-pay-page__content">
          <p>This is the cost of buying each year and when you must pay by.</p>
          <table class="table">
            <thead>
              <tr>
                <th><div class="text-center">Year</div></th>
                <th><div class="text-center">Class 2</div></th>
                <th><div class="text-center">Class 3</div></th>
                <th><div class="text-center">Deadline</div></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="text-center">2019 to 2020</div>
                </td>
                <td>
                  <div class="text-center">£166.95</div>
                </td>
                <td>
                  <div class="text-center">£840.05</div>
                </td>
                <td>
                  <div class="text-center">05-Apr-26</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-center">2020 to 2021</div>
                </td>
                <td>
                  <div class="text-center">£163.80</div>
                </td>
                <td>
                  <div class="text-center">£795.60</div>
                </td>
                <td>
                  <div class="text-center">05-Apr-27</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-center">2021 to 2022</div>
                </td>
                <td>
                  <div class="text-center">£158.60</div>
                </td>
                <td>
                  <div class="text-center">£800.80</div>
                </td>
                <td>
                  <div class="text-center">05-Apr-28</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-center">2022 to 2023</div>
                </td>
                <td>
                  <div class="text-center">£163.80</div>
                </td>
                <td>
                  <div class="text-center">£824.20</div>
                </td>
                <td>
                  <div class="text-center">05-Apr-29</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-center">2023 to 2024</div>
                </td>
                <td>
                  <div class="text-center">£179.40</div>
                </td>
                <td>
                  <div class="text-center">£907.40</div>
                </td>
                <td>
                  <div class="text-center">05-Apr-30</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-center">2024 to 2025</div>
                </td>
                <td>
                  <div class="text-center">£179.40</div>
                </td>
                <td>
                  <div class="text-center">£907.40</div>
                </td>
                <td>
                  <div class="text-center">05-Apr-31</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-center">2025 to 2026</div>
                </td>
                <td>
                  <div class="text-center">£185.5</div>
                </td>
                <td>
                  <div class="text-center">£940.75</div>
                </td>
                <td>
                  <div class="text-center">05-Apr-32</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-center">2026 to 2027</div>
                </td>
                <td>
                  <div class="text-center">n/a</div>
                </td>
                <td>
                  <div class="text-center">TBC</div>
                </td>
                <td>
                  <div class="text-center">05-Apr-33</div>
                </td>
              </tr>
            </tbody>
          </table>
          <p>The UK tax year starts 6th April every year.</p>
          <p>Only AFTER 6th April are you able to buy the most recent year which ended 5th April.</p>
          <table class="table-border">
            <tbody>
              <tr>
                <td>
                  <div><b>EXAMPLE:</b> If today was the 10th April 2029…</div>
                  <ul class="mt-4">
                    <li>You could NOT buy the 6th April 2029 – 5th April 2030 year</li>
                    <li>
                      You could ONLY buy the 6th April 2028 – 5th April 2029 year (<i
                        >and the previous 5 years if you didn’t already</i
                      >)
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <p><b>STEP 1) DO BANK TRANSFER</b></p>
          <p>
            <b><i>If paying from a Bank Account Outside UK</i></b>
          </p>
          <table class="table-border">
            <tbody>
              <tr>
                <td>
                  <b>Receiver Account Name</b>
                </td>
                <td>HMRC NIC RECEIPTS</td>
              </tr>
              <tr>
                <td>
                  <b>Receiver Address</b>
                </td>
                <td>National Insurance Contributions & Employer Office, BX5 5BD, UK</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <b>Receiver Sort Code</b>
                </td>
                <td>20 20 48</td>
              </tr>
              <tr>
                <td>
                  <b>Receiver Account Number</b>
                </td>
                <td>30944793</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <b>Receiver SWIFT/BIC</b>
                </td>
                <td>BARCGB22</td>
              </tr>
              <tr>
                <td>
                  <b>Receiver IBAN</b>
                </td>
                <td>GB49 BARC 2020 4830 9447 93</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <b>Receiver Bank Name</b>
                </td>
                <td>Barclays Bank PLC</td>
              </tr>
              <tr>
                <td><b>Receiver Bank Address</b></td>
                <td>1 Churchill Place, London, E14 5HP, UK</td>
              </tr>
            </tbody>
          </table>
          <p>
            <b><i>OR - If paying from a UK Bank Account</i></b>
          </p>
          <table class="table-border">
            <tbody>
              <tr>
                <td><b>Receiver Account Name</b></td>
                <td>HMRC NIC RECEIPTS</td>
              </tr>
              <tr>
                <td><b>Receiver Address</b></td>
                <td>National Insurance Contributions & Employer Office, BX5 5BD, UK</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td><b>Receiver Sort Code</b></td>
                <td>08 32 20</td>
              </tr>
              <tr>
                <td><b>Receiver Account Number</b></td>
                <td>12001004</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td><b>Receiver Bank Name</b></td>
                <td>Barclays Bank PLC</td>
              </tr>
              <tr>
                <td><b>Receiver Bank Address</b></td>
                <td>1 Churchill Place, London, E14 5HP, UK</td>
              </tr>
            </tbody>
          </table>
          <p><b>STEP 2) INCLUDE YOUR PAYMENT REFERENCE WHEN SENDING MONEY</b></p>
          <p class="text-center text-red-color">NATIONAL INSURANCE NUMBER + IC + SURNAME + FIRST INITIAL</p>
          <p>
            (Include as much as you can in the reference field if your name is long. Use UPPER CASE, no spaces /
            apostrophes)
          </p>
          <p><b>STEP 3) CHECK YOUR PAYMENT ARRIVED</b></p>
          <ol>
            <li>We’ll check your payment was received</li>
            <li>We’ll tell you what HMRC said and the Sterling amount they received from you.</li>
            <li>
              <u class="cursor-pointer" @click="navigateTo('Contact Us')">PLEASE CHECK my Payment Was Received</u> (<i
                >wait a week after you paid before asking us</i
              >)
            </li>
            <li>
              We’ll also check 6 months later that they’ve correctly allocated your payment to the correct past years
            </li>
          </ol>
          <p class="text-center"><b>Tips</b></p>
          <p><b>Send HMRC Payment in Sterling, not Euro/Dollar/Other Equivalent</b></p>
          <p>
            We recommend that you simply send Sterling to HMRC from your bank rather than the Euro/Dollar/Other
            Equivalent to avoid potential under / over payments. HMRC will refund any overpayments made in error. They
            will write to you if they do not know what your payment is to be allocated against.
          </p>
          <p><b>WARNING re HMRC Account Name</b></p>
          <p>
            'HMRC NIC Receipts' is the correct account name but may <b><u>NOT be verified by your bank</u></b> depending
            on if you use HMRC's IBAN instead of their Sort Code / Account Number as given above (due to recent SEPA
            changes)
          </p>
          <ul>
            <li>This account name is usually verified if using HMRC's Sort Code / Account Number</li>
            <li>
              This account name is usually NOT verified if using HMRC's IBAN - <b>but payment still gets to HMRC.</b>
            </li>
          </ul>
          <p>
            <i
              >Alternatively, if you're paying HMRC from a bank account <u>within</u> the UK, you can use 'HMRC NIC
              Receipts or GBS Re NICO Receipts or GBS Re NICO Receipts HMRC' which all show as verified by your bank.</i
            >
          </p>
        </div>
      </VCol>
    </VRow>
  </VContainer>
</template>
<script>
import { mapActions } from 'vuex';
// Components
// Utils
export default {
  name: 'HowToPayPage',
  components: {},
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    navigateTo(pageName) {
      if (!pageName) {
        return;
      }
      this.$router.push({ name: pageName });
    }
  }
};
</script>
